import React, { useRef, useState, useEffect, useContext } from 'react'
import { 
    Container,
    HeaderDiv,
    HeaderText,
    CloseDiv,
    CloseImg,
    OptionTabDiv,
    OptionImg,
    OptionTextDiv,
    OptionMainText,
    OptionSubText,
    ArrowImg,
    CancelButton
 } from './style'
import ModalContext from '../../contexts/ModalContext'
import signIn from '../../assets/addStockModal/sign-in.svg'
import arrow from '../../assets/addStockModal/arrow-right.svg'
import keyboard from '../../assets/addStockModal/keyboard.svg'
import cross from '../../assets/addStockModal/cross.svg'
import StockContext from '../../contexts/StockContext'
import { useNavigate } from 'react-router-dom'
import { useTenant } from '../../contexts/TenantContext'

const AddStockMenu: React.FC = () => {
  const navigate = useNavigate()
  const { isFashionTenant } = useTenant()
  const { setModalActive, setModalSection, setItIsUpdate, stockMode, isResourceModal } = useContext(ModalContext)

  const isFashion = stockMode === 'fashion' || isFashionTenant
  const isResource = isResourceModal || window.location.pathname.includes('/resource')
  const headerTitle = isResource
    ? (isFashion ? 'Adicionar aviamento' : 'Adicionar insumo')
    : (isFashion ? 'Adicionar tecido' : 'Adicionar estoque')
  const manualAddSubtitle = isResource
    ? (isFashion ? 'Insira os dados do aviamento de forma customizada' : 'Insira os dados do insumo de forma customizada')
    : (isFashion ? 'Insira os dados do tecido de forma customizada' : 'Insira os dados de forma customizada')

  const clickAddStock = () => {
    if (isResource) {
      setModalActive(false)
      navigate('/panel/stock/resource/create')
      return
    }
    setItIsUpdate(false)
    setModalSection('firstCustomAdd')
  }

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>{headerTitle}</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <OptionTabDiv onClick={() => setModalSection('firstExcelAdd')}>
        <OptionImg src={signIn} alt='Sign-in Icon' />
        <OptionTextDiv>
          <OptionMainText>Importar tabela</OptionMainText>
          <OptionSubText>A partir do upload de um arquivo local</OptionSubText>
        </OptionTextDiv>
        <ArrowImg src={arrow} alt='Arrow icon' />
      </OptionTabDiv>
      <OptionTabDiv onClick={() => clickAddStock()}>
        <OptionImg src={keyboard} alt='Keyboard icon' />
        <OptionTextDiv>
          <OptionMainText>Adicionar manualmente</OptionMainText>
          <OptionSubText>{manualAddSubtitle}</OptionSubText>
        </OptionTextDiv>
        <ArrowImg src={arrow} alt='Arrow icon' />
      </OptionTabDiv>
      <CancelButton onClick={() => setModalActive(false)}>Cancelar</CancelButton>
    </Container>
  )
}

export default AddStockMenu